import React from 'react';
import { useDispatch } from 'react-redux';
import { AuthenticationGatekeeper } from '@lwtears/lwt-common-frontend/lib/AuthenticationGatekeeper';
import { useLwtStore } from '@lwtears/lwt-common-frontend/lib/LwtApp';
import AuthenticatedApp from '../views/App';
import AppInit from '../components/AppInit';
import Loading from '../components/Loading';
import { loadUser } from './load-user';

const GatedApp = () => {
  const dispatch = useDispatch();
  const [, lwtStoreDispatch] = useLwtStore();

  return (
    <AuthenticationGatekeeper
      Loading={<Loading />}
      onAuthenticated={loadUser(dispatch, lwtStoreDispatch)}
      options={{ getUserParams: ['settings'] }}
    >
      <AppInit>
        <AuthenticatedApp />
      </AppInit>
    </AuthenticationGatekeeper>
  );
};

export default GatedApp;
